<div fxLayout="column" style="padding-left: 55px; padding-right: 55px; background: #f3f2ef;">
    <div fxLayout="row" style="margin-top: 50px; font-size: 18px; margin-bottom: 50px;" fxFlex
         fxLayoutAlign="start center center">
        Δημιουργία προσαρμοσμένης δήλωσης
    </div>

    <div fxLayout="row" fxFlex fxLayoutGap="15px">
        <div fxLayoutAlign="start center center" fxLayout="row" fxLayoutGap="5px">
            <div>
                <b>Τίτλος:</b>
            </div>
            <div>
                <mat-form-field>
                    <label>
                        <input matInput [(ngModel)]="formTitle" placeholder="Τίτλος δήλωσης"/>
                    </label>
                </mat-form-field>
            </div>
        </div>
        <div fxLayoutAlign="start center center" fxLayout="row" fxLayoutGap="5px">
            <div>
                <b>Περιγραφή:</b>
            </div>
            <div>
                <mat-form-field>
                    <label>
                        <input matInput [(ngModel)]="formDescription" placeholder="Περιγραφή δήλωσης"/>
                    </label>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div fxLayout="row" fxFlex fxLayoutGap="15px">

        <!--        Left Side-->
        <div fxLayout="column"  fxLayoutAlign="start" fxFlex="30"  >

            <div fxLayout="row" fxLayoutAlign="end center center" style="margin-bottom: 5px;">
                <div>
                    <button mat-raised-button color="primary" (click)="setSections()">Προσθήκη νέου τμήματος</button>
                </div>
            </div>

            <div style='height: 700px; overflow-y: auto;' cdkDropList
                 [cdkDropListData]="sections"
                 (cdkDropListDropped)="drop($event)">
            <div fxLayout="row" *ngFor="let section of sections" cdkDrag>
                <mat-expansion-panel [expanded]="section.expanded" fxFlex expanded="true" class="mat-elevation-z3" style="margin-bottom: 10px; overflow-x: auto;">
                    <mat-expansion-panel-header class="panel">
                        <mat-panel-title>
                            <div>Τμήμα {{section.id}} - {{section.value}}</div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="center center center" fxLayoutGap="5px">
                            <div>
                                <button mat-raised-button (click)="removeSection(section.id)" matTooltip="Αφαίρεση"
                                        style="color: red">
                                    Διαγραφή τμήματος
                                </button>
                            </div>
                        </div>
                        <div fxLayoutAlign="start center center" fxLayoutGap="5px" fxLayout="row">
                            <div>{{section.label}}</div>
                            <div>
                                <mat-form-field>
                                    <label>
                                        <input matInput [(ngModel)]="section.value">
                                    </label>
                                </mat-form-field>
                            </div>
                        </div>
                        <div fxLayoutAlign="start center center" fxLayoutGap="5px" fxLayout="row">
                            <div>{{section.subLabel}}</div>
                            <div>
                                <mat-form-field>
                                    <label>
                                        <input matInput [(ngModel)]="section.subLabelValue">
                                    </label>
                                </mat-form-field>
                            </div>
                        </div>
<!--                        <div fxLayoutAlign="start center center" fxLayoutGap="5px" fxLayout="row">-->
<!--                            <div>Προσανατολισμός</div>-->
<!--                            <div>-->
<!--                                <mat-form-field>-->
<!--                                    <mat-select [(ngModel)]="section.direction">-->
<!--                                        <mat-option *ngFor="let type of directionTypes"-->
<!--                                                    [value]="type">{{type.label}}</mat-option>-->
<!--                                    </mat-select>-->
<!--                                </mat-form-field>-->
<!--                            </div>-->
<!--                        </div>-->

                        <div fxLayout="row" fxLayoutAlign="start center center" fxFlex fxLayoutGap="5px">
                            <div fxLayout="column" fxFlex>
                                <div fxLayout="row" fxLayoutAlign="end center center " fxLayoutGap="5px" style="margin-bottom: 5px;">
                                    <button fxShow.gt-md fxHide.lt-lg mat-raised-button (click)="addMember(section.id)" color="primary">Προσθήκη νέας επιλογής</button>
                                    <button fxShow.lt-lg fxHide.gt-lg mat-icon-button (click)="addMember(section.id)" color="primary"><mat-icon color="primary">add</mat-icon></button>
<!--                                    <div>Επιλογές</div>-->
<!--                                    <div>-->
<!--                                        <mat-icon (click)="addMember(section.id)" matTooltip="Δημιουργία επιλογής"-->
<!--                                                  style="color: green">add-->
<!--                                        </mat-icon>-->
<!--                                    </div>-->
                                </div>

                                <div fxLayout="row" fxFlex *ngFor="let member of section.members"
                                     style="border-bottom: 1px solid lightgray; margin-bottom:5px; margin-left: 5px;">
                                    <div fxLayout="column" fxFlex>
                                        <div fxLayout="row" fxLayoutAlign="start center center" fxLayoutGap="5px">
                                            <div>Τίτλος</div>
                                            <div>
                                                <mat-form-field>
                                                    <label>
                                                        <input matInput [(ngModel)]="member.title"
                                                               placeholder="Τίτλος"/>
                                                    </label>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxFlex fxLayoutAlign="start center center" fxLayoutGap="5px">
                                            <div>Τύπος</div>
                                            <div fxFlex>
                                                <mat-form-field>
                                                    <mat-select [(ngModel)]="member.type">
                                                        <mat-option *ngFor="let type of sectionTypes"
                                                                    [value]="type">{{type.label}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutGap="5px" fxFlex
                                                 *ngIf="member.type.type !== 'text' && member.type.type !== 'toggle'">
                                                <mat-icon (click)="addOption(section.id, member.id)">edit</mat-icon>
                                            </div>

                                            <div fxLayoutAlign="end center center">
                                                <button mat-raised-button (click)="removeMember(section.id, member.id)" color="danger">Διαγραφή επιλογής</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </div>
            </div>
        </div>
        <!---->

        <!--        Right Side-->
        <div fxLayout="column" fxFlex="70" style='height: 700px; background-color: white; overflow-y: auto;'>
            <div fxLayout="row" fxFlex>

                <div #htmlDivElement fxLayout="column" fxFlex>

                    <div fxFlex *ngFor="let section of sections" style="padding: 10px; width: 100%;">

                        <div fxFlex fxLayout="row" fxLayoutAlign="start start center"
                             style="min-height: 150px !important; margin-bottom: 10px;">

                            <div fxLayout="column" fxFlex="45" [fxLayoutAlign]="section.direction.type">
                                <div fxLayout="row">
                                    <div style="font-weight: bold">
                                        {{section.value}}
                                    </div>
                                </div>

                                <div fxLayout="row" style="margin-top: 10px;">
                                    <div style="font-weight: normal; font-size: 12px;">
                                        {{section.subLabelValue}}
                                    </div>
                                </div>
                            </div>

                            <div fxLayout="column" fxFlex="55">
                                <div fxFlex fxLayout="row" *ngFor="let member of section.members"
                                     style="margin-bottom: 10px;">
                                    <div fxFlex fxLayout="column" style=" width: 100%;">
                                        <div fxLayout="row" *ngIf="member.type.type !== 'label'">
                                            {{member.title}}
                                        </div>

                                        <div fxLayout="row" fxFlex style="margin-top: 10px;">
                                            <div *ngIf="member.type.type === 'text'" fxFlex>
                                                <mat-form-field appearance="outline" fxFlex>
                                                    <label>
                                                        <input style="width: 100%;" matInput placeholder="Κείμενο"/>
                                                    </label>
                                                </mat-form-field>
                                            </div>
                                            <div *ngIf="member.type.type === 'textarea'" fxFlex>
                                                <mat-form-field appearance="outline" fxFlex>
                                                <label>
                                                    <textarea matInput [(ngModel)]="member.value"></textarea>
                                                </label>
                                                </mat-form-field>
                                            </div>
                                            <div fxLayout="column" fxLayoutGap="10px" *ngIf="member.type.type === 'checkbox'" fxFlex>
                                                <mat-checkbox *ngFor="let option of member.options">{{option.label}}</mat-checkbox>
                                            </div>
                                            <div *ngIf="member.type.type === 'label'" fxFlex>
                                                {{member.title}}
                                            </div>
                                            <div *ngIf="member.type.type === 'radio'" fxFlex>
                                                <mat-radio-group [(ngModel)]="member.value" fxLayout="row wrap">
                                                    <mat-radio-button style="margin: 5px;"
                                                                      *ngFor="let option of member.options"
                                                                      [value]="option">{{option.label}}</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <div *ngIf="member.type.type === 'toggle'" fxFlex>
                                                <mat-slide-toggle>ΝΑΙ/ΟΧΙ</mat-slide-toggle>
                                            </div>
                                            <div *ngIf="member.type.type === 'select'" fxFlex>
                                                <mat-form-field appearance="outline" fxFlex>
                                                    <mat-select [(ngModel)]="member.value">
                                                        <mat-option *ngFor="let option of member.options"
                                                                    [value]="option">{{option.label}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>

                </div>

            </div>
        </div>
        <!--        -->
    </div>

    <div fxLayout="row" fxLayoutAlign="center center center" style="margin-top: 20px; margin-bottom: 20px;">
        <button *ngIf="!mode" (click)="submitForm()" [disabled]="isFormInValid()" mat-raised-button color="primary" style="border-radius: 50px;">Δημιουργία δήλωσης</button>
        <button *ngIf="mode" (click)="updateForm()" [disabled]="isFormInValid()" mat-raised-button color="primary" style="border-radius: 50px;">Ενημέρωση δήλωσης</button>
    </div>
</div>
